import * as React from 'react'

import { useDomain } from './hooks'
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormCheck,
  CFormInput,
  CMultiSelect,
  CRow,
} from '@coreui/react-pro'
import { setDomain, submitSaveDomain } from './model'
import { Button, Divider, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'

export const DomainCreateDetail = () => {
  const { domain, loading, error } = useDomain()

  const handleChange = (event: {
    target: { name: any; type: string; checked?: any; value: any }
  }) => {
    const value =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value
    setDomain({
      ...domain,
      [event.target.name]: value,
    })
  }
  return (
    <div>
      {error.message.length > 0 && (
        <CAlert color="danger">Error code: {error.message}</CAlert>
      )}
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Add domain</strong>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CFormInput
                id="domain"
                name="domain"
                value={domain.domain}
                label="Domain"
                onChange={handleChange}
              />
              <Divider />
              <CButton
                color="success"
                className="ms-2"
                onClick={() => {
                  submitSaveDomain(domain)
                }}
              >
                Save domain
              </CButton>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </div>
  )
}
